export enum MeterId {
  LOCALE_CLOCK_WIDGET = 'locale_clock_widget',
  BIG_CLOCK = 'big_clock',
  LOCALE_CLOCK = 'locale',
  TIME = 'time',
  SPEED = 'speed',
  TEMPERATURE = 'temperature',
  WIND = 'wind',
  HEADING = 'heading',
  COMPASS = 'compass',
  DEPTH = 'depth',
  PRESSURE = 'pressure',
  MECCA = 'mecca',
  EARTH = 'earth',
  ECO_SCORE = 'eco_score',
}

export enum MeterType {
  TIME = MeterId.TIME,
  SPEED = MeterId.SPEED,
  TEMPERATURE = MeterId.TEMPERATURE,
  WIND = MeterId.WIND,
  HEADING = MeterId.HEADING,
  COMPASS = MeterId.COMPASS,
  DEPTH = MeterId.DEPTH,
  PRESSURE = MeterId.PRESSURE,
  MECCA = MeterId.MECCA,
  EARTH = MeterId.EARTH,
  ECO_SCORE = MeterId.ECO_SCORE,
}

export interface MeterOptions {
  [MeterType.TIME]: {
    displayValue?: boolean,
    isBig?: boolean
  }
}

export enum GaugeKey {
  TIME = 'times',
  SPEED = 'speed_distance',
  DISTANCE = 'distance',
  DEPTH = 'depth',
  PRESSURE = 'barometric_pressure',
  WIND = 'wind',
  TEMPERATURE = 'temperatures',
  MECCA = 'makkah',
  MAP = 'map',
  ECO_SCORE = MeterId.ECO_SCORE,
}
